import { render, staticRenderFns } from "./WizardStepResult.vue?vue&type=template&id=47ac4b0b&scoped=true"
import script from "./WizardStepResult.vue?vue&type=script&lang=js"
export * from "./WizardStepResult.vue?vue&type=script&lang=js"
import style0 from "./WizardStepResult.vue?vue&type=style&index=0&id=47ac4b0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ac4b0b",
  null
  
)

export default component.exports